import { RootState } from '@/store/index';
import { ActionContext, ActionTree } from 'vuex';
import { eventsHub } from '@/main';
import { SystemState } from '@/store/modules/system/index';
import {
  CHECK_CREDENTIALS,
  CREATE_FORMS_FILTERS,
  CREATE_STATISTICS,
  EMPLOYEE_DETAILS_UPDATE,
  EMPLOYEE_REMINDERS_PRE_SEND,
  EMPLOYEE_REMINDERS_SEND,
  GET_JOB_LOG,
  GET_JOBS_LOGS_LIST,
  GET_QUARTZ_INFO,
  GET_SYSTEM_CACHE_LIST,
  MAINTENANCE_PAGE,
  PAUSE_QUARTZ_TRIGGER,
  PROCESS_COMPARE_REQUESTS,
  REFRESH_APPLICATION_USER_VIEW,
  RELOAD_CACHE,
  RESUME_QUARTZ_TRIGGER,
  RUN_FORM_101_PDF_COMSIGN_JOB,
  RUN_FORM_101_PDF_FILES_EXPORT_JOB,
  RUN_FORM_101_PDF_GENERATOR_JOB,
  SET_LOGIN_PENDING,
  SET_PROCESS_COMPARE_REQUESTS_ERRORS,
  SET_PROCESS_COMPARE_REQUESTS_LOADING,
  SET_QUARTZ_INFO,
  SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS,
  SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS,
  SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS,
  SET_SYSTEM_CACHE_LIST,
  SET_SYSTEM_ERRORS,
  SET_SYSTEM_JOBS_ERRORS,
  SET_SYSTEM_JOBS_LOGS_LIST,
  SET_SYSTEM_QUARTZ_ERRORS,
  SET_SYSTEM_STATISTICS_ERRORS,
  SET_TEST_MAILS_ERRORS,
  SET_TOKEN,
  STANDBY_QUARTZ_SCHEDULER,
  START_QUARTZ_SCHEDULER,
  SYSTEM_INFO_ACCESSIBLE,
  TEST_MAILS,
  UPDATE_FORM_101_FILTERS,
  REFRESH_INDEX_DATA_BASE,
  STATISTICS_REPORT,
  SET_STATISTICS_REPORT_ERRORS,
} from '@/types/system.types';
import SystemService from '@/services/system.service';
import { $httpClient } from '@/services/httpClient';
import { systemInfoTokenInterceptor } from '@/globals/http.interceptors';
import { SystemLogin } from '@/models/system/SystemLogin';
import { finalize, pluck } from 'rxjs/operators';
import { RefreshCache } from '@/models/system/RefreshCache';
import { RunForm101PdfJobRequest } from '@/models/system/RunForm101PdfJobRequest';
import { TestMailsRequest } from '@/models/system/TestMailsRequest';
import { ProcessCompareRequest } from '@/models/system/process-compare-request';
import { Utils } from '@/globals/Utils';
import { StatisticsReportRequest } from '@/models/system/StatisticsReportRequest';

const systemService = new SystemService();
$httpClient.addRequestInterceptor(systemInfoTokenInterceptor);


export const actions: ActionTree<SystemState, RootState> = {

  [CHECK_CREDENTIALS]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    credentials: SystemLogin,
  ) => {

    commit(SET_LOGIN_PENDING, true);

    systemService.checkCredentials(credentials)
      .pipe(
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        (data: { body: string }) => {
          commit(SET_TOKEN, data.body);
          eventsHub.$router.push({ name: 'system-info-page' });
        },
        error => commit(SET_SYSTEM_ERRORS, error.messages ||
          [eventsHub.$t('login.network_error')]),
      );
  },

  [SYSTEM_INFO_ACCESSIBLE]: (
    { commit }: ActionContext<SystemState, RootState>,
  ) => {
    commit(SET_LOGIN_PENDING, true);
    systemService.systemInfoAccessible()
      .pipe(
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        data => {
          // success
        },
        error => {
          commit(SET_SYSTEM_ERRORS, error.messages ||
            [eventsHub.$t('login.network_error')]);
          eventsHub.$router.push({ name: 'system-info-login' });
        },
      );
  },

  [GET_SYSTEM_CACHE_LIST]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {

    systemService.getSystemCacheList()
      .pipe(
        pluck('systemCacheList'),
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        data => {
          commit(SET_SYSTEM_CACHE_LIST, data);
          eventsHub.$router.push({ name: 'system-info-page' });
        },
        error => commit(SET_SYSTEM_ERRORS, error.messages ||
          [eventsHub.$t('login.network_error')]),
      );
  },

  [RELOAD_CACHE]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    refreshCache: RefreshCache,
  ) => {
    systemService.reloadCache(refreshCache)
      .pipe(
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        data => {
          // success
          /*state.refreshMessage =  eventsHub.$t('views.systemInfoPage.refreshSuccess').toString();*/

          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshSuccess'),
          });
          /*eventsHub.$notify({
            group: 'toast',
            type: 'show',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshSuccess')
          });*/
          /*eventsHub.$notify({
            group: 'form',
            type: 'success',
            text: '' + eventsHub.$t('password_changed_successfully')
          });*/
        },
        error => {
          // error
          /*state.refreshMessage = eventsHub.$t('views.systemInfoPage.refreshFailed').toString();*/

          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshFailed'),
          });
        },
      );
  },

  [GET_JOBS_LOGS_LIST]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    searchJobsObject: any,
  ) => {

    systemService.getJobsLogsList(searchJobsObject)
      .pipe(
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        (data: any) => {
          const jobs = { resultCount: data.resultCount || 0, results: data.results };
          commit(SET_SYSTEM_JOBS_LOGS_LIST, jobs);
          eventsHub.$router.push({ name: 'system-info-page' });
        },
        error => {
          commit(SET_SYSTEM_ERRORS, error.messages ||
            [eventsHub.$t('login.network_error')]);

          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + error.messages,
          });
        },
      );
  },

  [GET_JOB_LOG]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    job: { jobId: number, jobDesc: string },
  ) => {

    systemService.getJobLog(job.jobId)
      .pipe(
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        data => {
          Utils.downloadBlobFile(new Blob([data], {
            type: 'text/plain;charset=utf-8',
          }), job.jobDesc + '_' + job.jobId + '.txt')
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + error.messages,
          });
        },
      );
  },


  [GET_QUARTZ_INFO]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {

    systemService.getQuartzInfo()
      .pipe(
        finalize(() => {
          commit(SET_LOGIN_PENDING, false);
        }),
      )
      .subscribe(
        data => {
          // success
          commit(SET_QUARTZ_INFO, data);
          eventsHub.$router.push({ name: 'system-info-page' });
        },
        error => {
          // error
          commit(SET_SYSTEM_QUARTZ_ERRORS, error.messages ||
            [eventsHub.$t('login.network_error')]);
        },
      );
  },

  [PAUSE_QUARTZ_TRIGGER]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    triggerName: string,
  ) => {
    return new Promise((resolve, reject) => {
      systemService.pauseQuartzTrigger(triggerName)
        .subscribe(
          data => {
            // success
            resolve(data);
          },
          error => {
            // error
            eventsHub.$notify({
              group: 'frd',
              type: 'error',
              text: '' + eventsHub.$t('login.action_failed'),
            });
            reject(error);
          },
        );
    });
  },

  [RESUME_QUARTZ_TRIGGER]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    triggerName: string,
  ) => {
    return new Promise((resolve, reject) => {
      systemService.resumeQuartzTrigger(triggerName)
        .subscribe(
          data => {
            // success
            resolve(data);
          },
          error => {
            // error
            eventsHub.$notify({
              group: 'frd',
              type: 'error',
              text: '' + eventsHub.$t('login.action_failed'),
            });
            reject(error);
          },
        );
    });
  },

  [START_QUARTZ_SCHEDULER]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {
    return new Promise((resolve, reject) => {
      systemService.startQuartzScheduler()
        .subscribe(
          data => {
            // success
            resolve(data);
          },
          error => {
            // error
            reject(error);
          },
        );
    });

  },

  [STANDBY_QUARTZ_SCHEDULER]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {

    return new Promise((resolve, reject) => {
      systemService.standbyQuartzScheduler()
        .subscribe(
          data => {
            // success
            resolve(data);
          },
          error => {
            // error
            reject(error);
          },
        );
    });

  },

  [CREATE_FORMS_FILTERS]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.createFormsFilters(state.formsFilters)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.form101Changes.addNoteSuccess'),
          });
        },
        error => commit(SET_SYSTEM_JOBS_ERRORS, error.messages),
      );

  },

  [CREATE_STATISTICS]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.createStatistics()
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('form101.wizard.form101Changes.addNoteSuccess'),
          });
        },
        error => commit(SET_SYSTEM_STATISTICS_ERRORS, error.messages),
      );

  },

  [RUN_FORM_101_PDF_GENERATOR_JOB]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    runForm101PdfGeneratorJobObj: RunForm101PdfJobRequest,
  ) => {
    commit(SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS, []);
    systemService.runForm101PdfGeneratorJob(runForm101PdfGeneratorJobObj)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.pdfGenerateSuccessMessage'),
          });
        },
        error => commit(SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS, error.messages),
      );
  },

  [RUN_FORM_101_PDF_FILES_EXPORT_JOB]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    runForm101PdfFilesExportJob: RunForm101PdfJobRequest,
  ) => {
    commit(SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS, []);
    systemService.runForm101PdfFilesExportJob(runForm101PdfFilesExportJob)
      .subscribe(
        () => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.pdfFilesexportSuccessMessage'),
          });
        },
        error => commit(SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS, error.messages),
      );
  },

  [RUN_FORM_101_PDF_COMSIGN_JOB]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    runForm101PdfComsignJob: RunForm101PdfJobRequest,
  ) => {
    commit(SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS, []);
    systemService.runForm101PdfComsignJob(runForm101PdfComsignJob)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.pdfComsignSuccessMessage'),
          });
        },
        error => commit(SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS, error.messages),
      );
  },

  [EMPLOYEE_REMINDERS_SEND]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.employeeRemindersSend()
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.employeeRemindersSendSuccessMessage'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('views.systemInfoPage.employeeRemindersSendErrorMessage'),
          });
        },
      );
  },

  [EMPLOYEE_REMINDERS_PRE_SEND]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.employeeRemindersPreSend()
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.employeeRemindersPreSendSuccessMessage'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('views.systemInfoPage.employeeRemindersPreSendErrorMessage'),
          });
        },
      );
  },

  [TEST_MAILS]: (
    { commit, dispatch, state }: ActionContext<SystemState, RootState>,
    testMailsRequest: TestMailsRequest,
  ) => {
    systemService.testMails(testMailsRequest)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.testMailsSuccessMessage'),
          });
        },
        error => commit(SET_TEST_MAILS_ERRORS, error.messages),
      );
  },

  [STATISTICS_REPORT]: (
    {commit, dispatch, state}: ActionContext<SystemState, RootState>,
    statisticsReportRequest: StatisticsReportRequest,
  ) => {
    systemService.statisticsReport(statisticsReportRequest)
      .subscribe(
        data => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.statisticsReportSuccessMessage'),
          });
        },
        error => {

          eventsHub.$notify({
            group: 'frd',
            type: 'error',
            text: '' + error.messages,
          });

          commit(SET_STATISTICS_REPORT_ERRORS, error.messages);
        },
      );
  },

  [PROCESS_COMPARE_REQUESTS]: (
    { commit, dispatch, state, rootGetters }: ActionContext<SystemState, RootState>,
    processCompareRequests: ProcessCompareRequest,
  ) => {
    commit(SET_PROCESS_COMPARE_REQUESTS_LOADING, false);
    commit(SET_PROCESS_COMPARE_REQUESTS_ERRORS, []);
    systemService.processCompareRequests(processCompareRequests.taxYear, processCompareRequests.indexNums,
      processCompareRequests.maxResult, processCompareRequests.firstResult)
      .pipe(
        finalize(() => commit(SET_PROCESS_COMPARE_REQUESTS_LOADING, false)),
      )
      .subscribe(
        (data) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.processCompareRequestsFinishedSuccessfully'),
          });
        },
        error => commit(SET_PROCESS_COMPARE_REQUESTS_ERRORS, error.messages),
      );
  },

  [EMPLOYEE_DETAILS_UPDATE]: (
    { commit, dispatch, state, rootGetters }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.employeeDetailsUpdate()
      .subscribe(
        (data) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.employeeDetailsUpdateFinishedSuccessfully'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.employeeDetailsUpdateError'),
          });
        },
      );
  },

  [REFRESH_APPLICATION_USER_VIEW]: (
    { commit }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.refreshApplicationUserView()
      .subscribe(
        (data) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshApplicationUserViewSuccess'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshApplicationUserViewError'),
          });
        },
      );
  },

  [MAINTENANCE_PAGE]: (
    { commit }: ActionContext<SystemState, RootState>,
    turnOnOrOff: boolean,
  ) => {
    systemService.maintenancePage(turnOnOrOff)
      .subscribe(
        (data) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.maintenancePageSuccess'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.maintenancePageError'),
          });
        },
      );
  },

  [UPDATE_FORM_101_FILTERS]: (
    { commit }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.updateForm101Filters()
      .subscribe(
        (data) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.updateForm101FiltersSuccess'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.updateForm101FiltersError'),
          });
        },
      );
  },

  [REFRESH_INDEX_DATA_BASE]: (
    { commit }: ActionContext<SystemState, RootState>,
  ) => {
    systemService.refreshIndexDatabase()
      .subscribe(
        (data) => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshIndexDatabaseSuccess'),
          });
        },
        error => {
          eventsHub.$notify({
            group: 'frd',
            type: 'success',
            text: '' + eventsHub.$t('views.systemInfoPage.refreshIndexDatabaseError'),
          });
        },
      );
  },

};

